import { RootState } from "../root-reducer";

export const selectAllProperties = (state: RootState) => state.properties.items;

export const selectPropertyById = (state: RootState, id: string) =>
  state.properties.items.find((property) => property.id === id);

export const selectPropertiesLoading = (state: RootState) =>
  state.properties.loading;

export const selectPropertiesError = (state: RootState) =>
  state.properties.error;
